import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a3a963c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 px-0" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-editieren",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = { class: "row mx-auto mt-3" }
const _hoisted_6 = { class: "col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow" }
const _hoisted_7 = { class: "col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow" }
const _hoisted_8 = { class: "col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow" }
const _hoisted_9 = {
  key: 0,
  class: "row mx-auto"
}
const _hoisted_10 = { class: "col-12 d-flex align-items-center bg-danger-teres p-3 justify-content-center my-3" }
const _hoisted_11 = { class: "row mx-auto mt-4" }
const _hoisted_12 = { class: "col-12 col-md-4 col-lg-3 offset-lg-1 mt-1 px-xs-0" }
const _hoisted_13 = {
  key: 0,
  class: "col-12 col-md-4 col-lg-3 mt-1 px-xs-0"
}
const _hoisted_14 = { class: "col-12 col-md-4 col-lg-3 mt-1 px-xs-0" }
const _hoisted_15 = { class: "mt-5 mb-2" }
const _hoisted_16 = {
  key: 2,
  class: "row list-unstyled mx-auto mt-0 mb-2 p-inline-start-0 adminreservation mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_confirmation_message = _resolveComponent("confirmation-message")!
  const _component_control_time = _resolveComponent("control-time")!
  const _component_control_integer = _resolveComponent("control-integer")!
  const _component_feedback_message = _resolveComponent("feedback-message")!
  const _component_button_cancel = _resolveComponent("button-cancel")!
  const _component_button_delete = _resolveComponent("button-delete")!
  const _component_button_save = _resolveComponent("button-save")!
  const _component_link_add_element = _resolveComponent("link-add-element")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.timeSlotEdit.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: { name: 'admin-time-slots', params: { id: _ctx.roomId } },
      i18nMessage: "common.backToOverview",
      class: "mt-2"
    }, null, 8, ["to"]),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      i18nErrorMessage: _ctx.$t('views.timeSlotEdit.errorGeneral')
    }, {
      default: _withCtx(() => [
        (_ctx.showDeleteConfirmation)
          ? (_openBlock(), _createBlock(_component_confirmation_message, {
              key: 0,
              i18nMessage: "views.timeSlotEdit.confirmDelete",
              i18nParams: [_ctx.room.name, _ctx.timeSlot.date, _ctx.timeSlot.startTime, _ctx.timeSlot.endTime],
              confirmButtonType: "delete",
              onCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteConfirmation = false)),
              onConfirmed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteTimeSlot()))
            }, null, 8, ["i18nParams"]))
          : _createCommentVNode("", true),
        (!_ctx.showDeleteConfirmation)
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
            }, [
              _createElementVNode("dl", _hoisted_4, [
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t('views.timeSlotEdit.room')), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.room.name || ''), 1),
                _createElementVNode("dt", null, _toDisplayString(_ctx.$t('views.timeSlotEdit.date')), 1),
                _createElementVNode("dd", null, _toDisplayString(_ctx.timeSlotDateFormatted || ''), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_control_time, {
                    i18nLabel: "common.timeSlot.startTime",
                    validation: _ctx.v$.startTime,
                    modelValue: _ctx.startTime,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.startTime) = $event)),
                    showBreak: true,
                    class: "d-flex flex-wrap align-items-center mr-3"
                  }, null, 8, ["validation", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_control_time, {
                    i18nLabel: "common.timeSlot.endTime",
                    validation: _ctx.v$.endTime,
                    modelValue: _ctx.endTime,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endTime) = $event)),
                    showBreak: true,
                    class: "d-flex flex-wrap align-items-center mr-3"
                  }, null, 8, ["validation", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_control_integer, {
                    i18nLabel: "common.timeSlot.capacity",
                    validation: _ctx.v$.capacity,
                    modelValue: _ctx.capacity,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.capacity) = $event)),
                    showBreak: true,
                    class: "d-flex flex-wrap align-items-center mr-3"
                  }, null, 8, ["validation", "modelValue"])
                ])
              ]),
              (_ctx.tickets.length !== 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_feedback_message, {
                        message: _ctx.$t('views.timeSlotEdit.notDeletable', { count: _ctx.tickets.length })
                      }, null, 8, ["message"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_button_cancel, {
                    to: { name: 'admin-time-slots', params: { id: _ctx.roomId } },
                    class: "btn-w-100"
                  }, null, 8, ["to"])
                ]),
                (_ctx.tickets.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_button_delete, {
                        i18nMessage: "common.timeSlot.delete",
                        onClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteConfirmation = true)),
                        class: "btn-w-100"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_button_save, {
                    i18nMessage: "views.timeSlotEdit.save",
                    class: "btn-w-100"
                  })
                ])
              ]),
              _createElementVNode("h2", _hoisted_15, _toDisplayString(_ctx.$t('views.timeSlotEdit.reservations')) + " (" + _toDisplayString(_ctx.tickets.length) + ")", 1),
              (_ctx.timeSlotInPast)
                ? (_openBlock(), _createBlock(_component_link_add_element, {
                    key: 1,
                    class: "d-flex justify-content-end mb-2",
                    to: { name: 'admin-time-slot-book', params: { roomId: _ctx.roomId, timeSlotId: _ctx.timeSlotId }, query: { fromSearch: 'y' }},
                    i18nMessage: "views.timeSlotEdit.addReservation"
                  }, null, 8, ["to"]))
                : _createCommentVNode("", true),
              (_ctx.timeSlotInPast)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tickets, (ticket, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: index,
                        class: "col-12"
                      }, [
                        _createVNode(_component_router_link, {
                          to: { name: 'admin-reservation-edit', params: { id: ticket.id }, query: { 'fromSearch': 'y' } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(ticket.firstName) + " " + _toDisplayString(ticket.lastName), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["state", "i18nErrorMessage"])
  ]))
}